<template>
    <v-card height="100%" width="256" class="mx-auto" v-if="user">
        <v-list-item>
            <v-list-item-content>
                <v-list-item-title class="text-h6">
                    Store Manager
                </v-list-item-title>
                <v-list-item-subtitle> {{ user.name }} </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-item v-if="this.user.role == 'Admin'">
            <v-list-item-content>
                <v-select
                    :items="shops"
                    v-model="user.selected_shop"
                    @change="changeShop"
                    label="Negozio"
                ></v-select>
            </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list dense nav>
            <div v-for="item in menuItemList" :key="item.title">
                <v-list-item v-if="!isSub(item)" link :to="item.url">
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-group v-if="isSub(item)" :prepend-icon="item.icon">
                    <template v-slot:activator>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </template>

                    <v-list-item
                        v-for="childItem in item.children"
                        :key="childItem.title"
                        link
                        :to="childItem.url"
                    >
                        <v-list-item-icon>
                            <v-icon>{{ childItem.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{
                                childItem.title
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </div>
        </v-list>
        <v-card-actions class="card-actions">
            <div class="pa-2">
                <v-btn block color="error" :href="'/api/logout'">
                    Logout
                </v-btn>
            </div>
        </v-card-actions>
    </v-card>
</template>
<style>
.card-outter {
    padding-bottom: 50px;
}

.card-actions {
    position: absolute;
    bottom: 0;
}
</style>
<script>
import requests from "../requests";
export default {
    name: "LateralMenu",
    computed: {
        menuItemList() {
            let arr = [];
            _.forEach(this.items, (m) => {
                if (this.isSub(m)) {
                    let tmp = _.cloneDeep(m);
                    tmp.children = [];
                    _.forEach(m.children, (subm) => {
                        if (this.checkRole(subm)) tmp.children.push(subm);
                    });
                    if (this.checkRole(m)) {
                        arr.push(tmp);
                    }
                } else {
                    if (this.checkRole(m)) arr.push(m);
                }
            });
            return arr;
        },
    },
    mounted() {
        this.user = window.currentUser;
    },

    data() {
        return {
            user: { selected_shop: null },
            shops: [
                {
                    text: "Jacob",
                    value: "J",
                },
                {
                    text: "Attilia",
                    value: "A",
                },
            ],
            items: [
                {
                    title: "Prodotti",
                    icon: "mdi-barcode",
                    url: "#",
                    role: "all",
                    id: "product",
                    children: [
                        {
                            title: "Lista",
                            icon: "mdi-playlist-check",
                            url: "/product-list",
                            role: "all",
                            id: "product-list",
                        },
                        {
                            title: "Vendite",
                            icon: "mdi-credit-card-multiple-outline",
                            url: "/product-sell",
                            role: "Admin",
                        },
                        {
                            title: "Alert Giacenze",
                            icon: "mdi-alert",
                            url: "/product-restock-alert",
                            role: "all",
                        },
                        {
                            title: "Alert Giacenze Negozi",
                            icon: "mdi-alert",
                            url: "/product-restock-alert-shop",
                            role: "all",
                        },
                        {
                            title: "Riordino Negozi",
                            icon: "mdi-reorder-horizontal",
                            url: "/product-reorder-shop",
                            role: "Admin",
                        },
                        {
                            title: "Rating (test)",
                            icon: "mdi-star",
                            url: {
                                name: "product-rating",
                            },
                            role: "Admin",
                        },
                        {
                            title: "Analisi Completa",
                            icon: "mdi-chart-box",
                            url: {
                                name: "product-comprehensive-analysis",
                            },
                            role: "all",
                        },
                        {
                            title: "Analisi EBITDA",
                            icon: "mdi-trending-up",
                            url: {
                                name: "product-ebitda-analysis",
                            },
                            role: "all",
                        },
                        {
                            title: "Analisi RESA",
                            icon: "mdi-resize",
                            url: {
                                name: "product-resa-analysis",
                            },
                            role: "all",
                        },
                        {
                            title: "Planogramma",
                            icon: "mdi-view-grid",
                            url: {
                                name: "planogram",
                            },
                            role: "all",
                        },
                    ],
                },
                {
                    title: "Shopify Product",
                    icon: "mdi-shopping",
                    url: "/shopify/product-list",
                    role: "Admin",
                },
                {
                    title: "Ordini",
                    icon: "mdi-file-table",
                    url: "#",
                    role: "all",
                    children: [
                        {
                            title: "Crea ordine",
                            icon: "mdi-plus",
                            url: "/create-order",
                            role: "all",
                        },
                        {
                            title: "Testate",
                            icon: "mdi-head",
                            url: "/testate-ordini",
                            role: "all",
                        },
                        {
                            title: "Report Riordino",
                            icon: "mdi-clipboard-text-multiple",
                            url: "/reorder-reports",
                            role: "Admin",
                        },
                    ],
                },

                {
                    title: "Leggi ordini",
                    icon: "mdi-file-table",
                    url: "/read-order",
                    role: "all",
                },
                {
                    title: "Scaffali",
                    icon: "mdi-bookshelf",
                    url: "#",
                    role: "all",
                    children: [
                        {
                            title: "Crea scaffale",
                            icon: "mdi-bookshelf",
                            url: {
                                name: "rack-list",
                            },
                            role: "Admin",
                        },
                        {
                            title: "Mappe",
                            icon: "mdi-map",
                            url: { name: "rack-map" },
                            role: "all",
                        },
                    ],
                },
                {
                    title: "Incassi",
                    icon: "mdi-currency-eur",
                    url: "#",
                    role: "all",
                    children: [
                        {
                            title: "Lista",
                            icon: "mdi-currency-eur",
                            url: "/incassi-list",
                            role: "all",
                        },
                        {
                            title: "KPI",
                            icon: "mdi-currency-eur",
                            url: "/kpi",
                            role: "all",
                        },
                        {
                            title: "Fatturati negozi",
                            icon: "mdi-currency-eur",
                            url: "/fatturati",
                            role: "all",
                        },
                        {
                            title: "Montanti",
                            icon: "mdi-currency-eur",
                            url: "/montanti",
                            role: "all",
                        },
                        {
                            title: "Montanti Week",
                            icon: "mdi-currency-eur",
                            url: "/montanti-week",
                            role: "all",
                        },
                    ],
                },
                {
                    title: "Shops",
                    icon: "mdi-basket ",
                    url: "/shop-list",
                    role: "Admin",
                },
                {
                    title: "Utenti",
                    icon: "mdi-account",
                    url: "/users",
                    role: "Admin",
                },
            ],
            right: null,
        };
    },

    methods: {
        changeShop() {
            requests.changeshop(this.user.selected_shop).then(() => {
                this.$router.go();
            });
        },
        checkRole(item) {
            if (this.user.role == "Solo Prodotti") {
                if (item.id == "product" || item.id == "product-list")
                    return true;
                else return false;
            }
            if (item.role == "all") return true;
            if (this.user.role == item.role) return true;
            return false;
        },

        isSub(item) {
            if (_.isUndefined(item.children) || item.children.length == 0)
                return false;
            return true;
        },
    },
};
</script>
